module.exports = __webpack_public_path__ + "img/IMG_6070_L_Foamcore_MockedUp.a0a91fa6.jpg";